module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-chunk-intro-card02@2x.833ac566.jpg";